import type { Match } from "../../types";
import { MatchCard } from "../MatchCard";

export function MatchesTab(
  { matches, onFeedback, feedbackPendingId, feedbackError }: {
    matches?: Match[];
    onFeedback?: (match: Match, feedback: "good" | "bad") => void;
    feedbackPendingId?: string | null;
    feedbackError?: string | null;
  },
) {
  if (!Array.isArray(matches) || matches.length === 0) {
    return (
      <div class="state-msg">
        Nenhum match retornado pelo W4 nesta conversa.
      </div>
    );
  }
  return (
    <>
      {feedbackError && <div class="state-error">{feedbackError}</div>}
      <div class="match-list">
        {matches.map((m) => (
          <MatchCard
            key={m.match_id || m.id}
            m={m}
            onFeedback={onFeedback}
            feedbackPending={feedbackPendingId === (m.match_id || m.id)}
          />
        ))}
      </div>
    </>
  );
}
